import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static targets = ["dialog", "input", "group", "row", "header", "add", "empty"]

  connect() {
    reactor(this)
    this.opened ??= false
    this.gated ??= false
    if (!this.hasDialogTarget) return

    this.opened ||= this.dialogTarget.open
    if (this.opened) {
      this.takeGate()
      this.restore()
    }
  }

  disconnect() {
    this.releaseGate()
  }

  open() {
    if (!this.hasDialogTarget) {
      const dialog = document.getElementById("next-context-picker")
      const host = dialog && this.application.getControllerForElementAndIdentifier(dialog, "context-picker")
      host?.open()
      return
    }

    if (this.opened) {
      this.restore()
      return
    }

    this.dialogTarget.showModal()
    this.opened = true
    this.takeGate()
    this.resetFilter()
    this.inputTarget.focus()
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) {
      this.dialogTarget.close()
    } else {
      this.closed()
    }
  }

  closed() {
    this.opened = false
    this.releaseGate()
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  morph() {
    if (this.opened) this.restore()
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let anyVisible = false

    this.groupTargets.forEach((group) => {
      const rows = group.querySelectorAll("[data-context-picker-target='row']")
      let groupVisible = query === ""

      rows.forEach((row) => {
        const haystack = (row.getAttribute("data-filter-text") || "").toLowerCase()
        const match = query === "" || haystack.includes(query)
        row.classList.toggle("hidden", !match)
        if (match) groupVisible = true
      })

      const header = group.querySelector("[data-context-picker-target='header']")
      const add = group.querySelector("[data-context-picker-target='add']")
      header?.classList.toggle("hidden", !groupVisible)
      add?.classList.toggle("hidden", !groupVisible)
      if (groupVisible) anyVisible = true
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", query === "" || anyVisible)
    }
  }

  restore() {
    if (!this.hasDialogTarget) return
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  resetFilter() {
    if (this.hasInputTarget) this.inputTarget.value = ""
    this.filter()
  }

  takeGate() {
    if (this.gated) return
    this.gated = true
    document.dispatchEvent(new CustomEvent("fsp:increment"))
  }

  releaseGate() {
    if (!this.gated) return
    this.gated = false
    document.dispatchEvent(new CustomEvent("fsp:decrement"))
  }
}
